import { render } from "./VideoClip.vue?vue&type=template&id=7fdf4693"
import script from "./VideoClip.vue?vue&type=script&lang=js"
export * from "./VideoClip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__